module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/live-components/src/components/Notice/images/audience-0528f6.svg";